import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEditinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 14L18 2l3.961 4.026L10 18zm3.25 4.25L3 21l2.75-6.25",
		fill: "none",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2
	})
});
export default SvgEditinline;
